import {updateSettingsValue} from "@twigsby/client-data";
import {
    ComboBoxControl,
    EmailControl, GenericLoader,
    TelephoneControl,
    ToggleSwitch,
    ToggleType,
    ValidationError,
} from "@twigsby/frontend-framework";
import React, {useState} from "react";
import {SettingsActionType} from "../SettingsTypes";

const UserAction = (item: SettingsActionType) => {
    const [updating, setUpdating] = useState<boolean>(false);
    const [ error, setError ] = useState<any>(null);

    const UpdateValue = (value: any) => {
        setUpdating(true);

        if(value !== item.value) {
            updateSettingsValue(item.resource, typeof(value) === 'string' ? value.trim() : value).then(r => {
                setError(null);
            })
            .catch((er) => {
                setError(er.Value);
            })
            .finally(() => {
                setUpdating(false);
            });
        } else {
            setUpdating(false);
        }
    };

    const MapArrayDefaultValue = () => {
        const defaultValueIndex = item?.options?.findIndex((entry: any) => entry.label === item.value);
        return defaultValueIndex !== undefined && defaultValueIndex !== -1 ? item.options[defaultValueIndex].value : item.value;
    }

    return (
        <>
            <div className={'user-action'}>
                <div className={'fade'}>{item.label}</div>
                <div>
                    {typeof(item.value) === 'boolean' ? (
                        <ToggleSwitch
                            name={item.label}
                            label={item.label}
                            type={ToggleType.Switch}
                            onChange={(e: any) => {
                                UpdateValue(e.currentTarget.checked);
                            } }
                            defaultChecked={item.value}
                            hideLabel={true}
                            disabled={updating}
                        />
                    ) : item.options ? (
                        <ComboBoxControl
                            name={item.label.replace(/ /g, '')}
                            placeholder={`Select ${item.label}...`}
                            data={item.options}
                            defaultValues={item.value ? [MapArrayDefaultValue()] : undefined}
                            disabled={updating}
                            valueType={'number'}
                            singleSelection={true}
                            forwardValueCallback={(e) => {
                                UpdateValue(e);
                            }}
                        />
                    ) : item.label === 'Telephone' || item.label === 'Mobile'? (
                            <TelephoneControl
                                name="phoneNo"
                                onBlurCallback={(e) => UpdateValue(e)}
                                defaultValue={item.value}
                                placeholder={'Telephone'}
                                disabled={updating}
                            />
                    ) : item.label === 'Email' ? (
                        <EmailControl
                            name={'email'}
                            placeholder={'E-mail'}
                            onBlurCallback={(email) => UpdateValue(email)}
                            defaultValue={item.value}
                            disabled={updating}
                        />
                    ) : (
                        <input
                            type={typeof(item.value) === 'number' ? 'number' : 'text'}
                            defaultValue={item.value}
                            disabled={updating}
                            onBlur={(e) => {
                                UpdateValue(e.target.value);
                            }}
                        />
                    )}
                </div>

                {updating && (
                    <GenericLoader/>
                )}
            </div>

            {error && (
                <ValidationError value={Object.entries(error)[0].toString()} />
            )}
        </>
    )
}

export default UserAction
